<palantir-accordion
  [title]="definition().label"
  [open]="true"
  #listBox
  cdkListbox
  cdkListboxMultiple
  (cdkListboxValueChange)="handleCheckboxChange($event.value)"
>
  @if (canShowFilter()) {
    <div class="multi-select-input">
      @if (definition().description?.length) {
        <palantir-text class="multi-select-input__description" size="base" type="description">{{
          definition().description
        }}</palantir-text>
      }
      @if (definition().search && definition().search?.enabled) {
        <palantir-input prefix="search-outline">
          <input
            type="text"
            [placeholder]="definition().search?.placeholder"
            [formControl]="searchControl"
            (keydown)="stopPropagation($event)"
          />
          <palantir-filter-modal-error-display
            palantir-input-error
            [control]="control()"
            [validatorsMessages]="definition().validatorsMessages"
          />
        </palantir-input>
      }
      <div class="multi-select-input__options palantir-scrollbar">
        @for (option of filteredOptions(); track option.value) {
          <div
            class="multi-select-input__options__option"
            [ngClass]="{
              'multi-select-input__options__option--with-description': option.description,
            }"
          >
            <palantir-checkbox
              [cdkOption]="option.value"
              [attr.checked]="control().value?.includes(option.value) ? 'true' : ''"
            />
            <palantir-filter-modal-option [option]="option" (click)="toggle(control(), option)" />
          </div>
        } @empty {
          @if (definition().search && definition().search?.enabled) {
            <div class="multi-select-input__empty-message">
              <palantir-icon
                name="search-outline"
                class="multi-select-input__empty-message__icon"
              />
              <palantir-text size="base" type="description">{{
                definition().search?.emptyMessage
              }}</palantir-text>
            </div>
          }
        }
      </div>
    </div>
  } @else {
    <div class="filter-dialog__banner">
      <palantir-icon name="info-outline" class="filter-dialog__banner__icon" />
      <palantir-text size="base" type="description">{{
        definition().dependsOn?.placeholder
      }}</palantir-text>
    </div>
  }
</palantir-accordion>
